// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1lKiE","header":"ClearentDisclaimer_header__2e-Pk","inner":"ClearentDisclaimer_inner__1cTln"};